export default "__VITE_ASSET__CEQR3U_A__"